import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full h-full rounded-full bg-gray-200 flex items-center justify-center text-sm font-semibold text-[#52526f]" }

import { getDoctorInitials } from '@/utils/string'


export default /*#__PURE__*/_defineComponent({
  __name: 'InitialsFallback',
  props: {
    name: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(getDoctorInitials)(_ctx.name)), 1))
}
}

})